export default __webpack_public_path__ + "static/media/firebase.d462adc6.svg";